/* Colborne Dental - conversion + attribution layer. Added 2026-08-23.
   Creates no tag container and removes none. Pushes to the existing dataLayer only. */
(function () {
  'use strict';

  /* idempotence: never register listeners twice if the asset is ever loaded twice */
  if (window.CD && window.CD.__init) { return; }

  var STORE_KEY = 'cd_attr_v1';
  var ATTR_KEYS = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','wbraid','gbraid','fbclid','msclkid'];
  var CANON_DIGITS = '7052591139';
  var CANON_TEL = 'tel:+1' + CANON_DIGITS;
  var LEAD_WINDOW_MS = 10000;

  window.dataLayer = window.dataLayer || [];
  var fired = {};
  var leadCount = 0;
  var lastLeadAt = 0;

  function safeGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function safeSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function now() { return new Date().getTime(); }

  /* ---------- attribution ---------- */
  function readParams() {
    var out = {};
    var sp;
    try { sp = new URLSearchParams(window.location.search); } catch (e) { return out; }
    ATTR_KEYS.forEach(function (k) { var v = sp.get(k); if (v) { out[k] = v; } });
    return out;
  }

  function attribution() {
    var stored = {};
    try { stored = JSON.parse(safeGet(STORE_KEY) || '{}') || {}; } catch (e) { stored = {}; }
    var fresh = readParams();
    var merged = {};
    ATTR_KEYS.forEach(function (k) {
      if (fresh[k]) { merged[k] = fresh[k]; }
      else if (stored[k]) { merged[k] = stored[k]; }
    });
    merged.first_landing_page = stored.first_landing_page || window.location.pathname;
    merged.first_referrer = typeof stored.first_referrer === 'string' ? stored.first_referrer : (document.referrer || '');
    if (Object.keys(fresh).length || !safeGet(STORE_KEY)) { safeSet(STORE_KEY, JSON.stringify(merged)); }
    return merged;
  }

  function leadSource(a) {
    if (a.gclid || a.wbraid || a.gbraid) { return 'google_ads'; }
    if (a.fbclid) { return 'meta_ads'; }
    if (a.msclkid) { return 'microsoft_ads'; }
    if (a.utm_source) { return a.utm_source; }
    var r = a.first_referrer || document.referrer || '';
    if (!r) { return 'direct'; }
    try {
      var h = new URL(r).hostname.replace(/^www\./, '');
      if (h === window.location.hostname.replace(/^www\./, '')) { return 'internal'; }
      return h;
    } catch (e) { return 'referral'; }
  }

  /* ---------- events ---------- */
  function push(event, params) {
    var a = attribution();
    var payload = {
      event: event,
      page_path: window.location.pathname,
      page_location: window.location.origin + window.location.pathname,
      lead_source: leadSource(a)
    };
    ATTR_KEYS.forEach(function (k) { if (a[k]) { payload[k] = a[k]; } });
    if (params) {
      for (var p in params) {
        if (Object.prototype.hasOwnProperty.call(params, p) && params[p] !== undefined && params[p] !== '') { payload[p] = params[p]; }
      }
    }
    window.dataLayer.push(payload);
    return payload;
  }

  function pushOnce(key, event, params) {
    if (fired[key]) { return null; }
    fired[key] = true;
    return push(event, params);
  }

  /* ---------- phone number normalisation ----------
     Some older hand-built sections link tel:7052591139 with no country code.
     Normalise every clinic number to the canonical E.164 form so tap-to-call
     and the click_to_call event are consistent sitewide. */
  function normaliseTels() {
    var links = document.querySelectorAll('a[href^="tel:"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      var digits = href.replace(/[^0-9]/g, '');
      if (digits === CANON_DIGITS || digits === '1' + CANON_DIGITS) {
        if (href !== CANON_TEL) { links[i].setAttribute('href', CANON_TEL); }
      }
    }
  }

  /* ---------- lead form iframes ---------- */
  function serviceGuess() {
    var h1 = document.querySelector('h1');
    return h1 ? (h1.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 90) : '';
  }

  function adopt() {
    var legacy = document.querySelectorAll('iframe[src*="leadconnectorhq.com/widget/form"]:not([data-cd-form-id])');
    for (var i = 0; i < legacy.length; i++) {
      var f = legacy[i];
      var provider = (f.getAttribute('data-form-id') || '').trim();
      f.setAttribute('data-cd-form-id', 'existing_page_form');
      f.setAttribute('data-cd-service', serviceGuess());
      if (provider) { f.setAttribute('data-cd-provider-id', provider); }
      if (!f.getAttribute('data-cd-src')) { f.setAttribute('data-cd-src', f.getAttribute('src') || ''); }
    }
  }

  function decorate(frame) {
    if (!frame || frame.getAttribute('data-cd-decorated') === '1') { return; }
    var base = frame.getAttribute('data-cd-src') || frame.getAttribute('src');
    if (!base) { return; }
    var a = attribution();
    var url;
    try { url = new URL(base, window.location.origin); } catch (e) { return; }
    ATTR_KEYS.forEach(function (k) { if (a[k]) { url.searchParams.set(k, a[k]); } });
    var svc = frame.getAttribute('data-cd-service');
    var fid = frame.getAttribute('data-cd-form-id');
    if (svc) { url.searchParams.set('service', svc); }
    if (fid) { url.searchParams.set('form_location', fid); }
    url.searchParams.set('page_path', window.location.pathname);
    url.searchParams.set('landing_page', a.first_landing_page || window.location.pathname);
    url.searchParams.set('lead_source', leadSource(a));
    frame.setAttribute('data-cd-decorated', '1');
    if (frame.getAttribute('src') !== url.toString()) { frame.setAttribute('src', url.toString()); }
  }

  function decorateAll() {
    adopt();
    var frames = document.querySelectorAll('iframe[data-cd-form-id]');
    for (var i = 0; i < frames.length; i++) { decorate(frames[i]); }
  }

  function frameMeta(source) {
    if (!source) { return null; }
    var frames = document.querySelectorAll('iframe[data-cd-form-id]');
    for (var i = 0; i < frames.length; i++) {
      if (frames[i].contentWindow === source) {
        return {
          form_id: frames[i].getAttribute('data-cd-form-id') || 'lead_form',
          service: frames[i].getAttribute('data-cd-service') || '',
          provider_form_id: frames[i].getAttribute('data-cd-provider-id') || ''
        };
      }
    }
    return null;
  }

  function looksLikeSubmit(data) {
    if (!data) { return false; }
    if (typeof data === 'string') { return /form[-_ ]?submit|submitted|submission[-_ ]?success|onFormSubmit/i.test(data); }
    if (typeof data === 'object') {
      var t = data.type || data.event || data.action || data.name || '';
      if (typeof t === 'string' && /form[-_ ]?submit|submitted|submission[-_ ]?success|onFormSubmit/i.test(t)) { return true; }
      if (data.formSubmitted === true || data.submitted === true) { return true; }
    }
    return false;
  }

  /* generate_lead fires ONLY from a message posted by the LeadConnector
     origin that reports a completed submission. No click path reaches it.

     Duplicate protection, in order:
       1. a message with no identifiable source frame is ignored once any
          lead has already been recorded on this page load;
       2. a 10 second global window treats repeats as the same submission -
          LeadConnector can emit the same event from both the iframe and
          the embed script;
       3. per-form keys stop the same form reporting twice. */
  function recordLead(meta, identified) {
    var t = now();
    if (!identified && leadCount > 0) { return; }
    if (t - lastLeadAt < LEAD_WINDOW_MS && leadCount > 0) { return; }
    var key = 'lead:' + meta.form_id;
    if (fired[key]) { return; }
    fired[key] = true;
    leadCount++;
    lastLeadAt = t;
    push('generate_lead', {
      form_id: meta.form_id,
      service: meta.service,
      provider_form_id: meta.provider_form_id,
      form_provider: 'leadconnector'
    });
  }

  window.addEventListener('message', function (e) {
    var o = String(e.origin || '');
    if (o.indexOf('leadconnectorhq.com') === -1 && o.indexOf('msgsndr.com') === -1) { return; }
    if (!looksLikeSubmit(e.data)) { return; }
    var meta = frameMeta(e.source);
    recordLead(meta || { form_id: 'lead_form', service: '', provider_form_id: '' }, !!meta);
  }, false);

  /* ---------- interaction events (single delegated listener) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }

    if (t.closest('chat-widget, [id^="lc_text-widget"], .lc_text-widget')) {
      pushOnce('chat', 'chat_start', { chat_provider: 'leadconnector' });
      return;
    }

    var el = t.closest('a,button');
    if (!el) { return; }

    var href = (el.getAttribute && el.getAttribute('href')) || '';
    if (href.indexOf('tel:') === 0) {
      var digits = href.replace(/[^0-9]/g, '');
      var num = (digits === CANON_DIGITS || digits === '1' + CANON_DIGITS) ? '+1' + CANON_DIGITS : href.replace('tel:', '');
      push('click_to_call', {
        form_id: el.getAttribute('data-cd-loc') || 'page_body',
        service: el.getAttribute('data-cd-service') || '',
        phone_number: num
      });
      return;
    }

    if (el.getAttribute && el.getAttribute('data-cd-book') !== null) {
      push('book_appointment_click', {
        form_id: el.getAttribute('data-cd-loc') || 'page_body',
        service: el.getAttribute('data-cd-service') || '',
        destination: href
      });
    }
  }, true);

  /* ---------- sticky bar spacing + chat coexistence ---------- */
  function sizeBar() {
    var bar = document.querySelector('.cd-sticky');
    var h = 0;
    if (bar && window.getComputedStyle(bar).display !== 'none') { h = Math.ceil(bar.getBoundingClientRect().height); }
    document.documentElement.style.setProperty('--cd-bar-h', h ? (h + 'px') : '0px');
  }

  function pass() { normaliseTels(); decorateAll(); sizeBar(); }

  function init() {
    attribution();
    pass();
    window.addEventListener('resize', sizeBar, { passive: true });
    window.addEventListener('orientationchange', sizeBar);
    setTimeout(pass, 500);
    setTimeout(pass, 1600);
    setTimeout(sizeBar, 3000);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }

  window.CD = {
    __init: true,
    attribution: attribution,
    push: push,
    leadSource: leadSource,
    decorateAll: decorateAll,
    normaliseTels: normaliseTels,
    leadCount: function () { return leadCount; }
  };
})();
